import script from "./DocumentsViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentsViewer.vue?vue&type=script&setup=true&lang=js"

import "./DocumentsViewer.vue?vue&type=style&index=0&id=93b2c6e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93b2c6e6"]])

export default __exports__